import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "d-flex flex-row pb-1 pt-1" };
const _hoisted_2 = { class: "h4 p-0 m-0 flex-fill" };
const _hoisted_3 = {
    key: 0,
    class: "d-flex flex-row"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "property-table__data mb-4" };
const _hoisted_6 = {
    key: 0,
    class: "row property-table-row property-table-row--type-description-list"
};
const _hoisted_7 = { class: "cell cell-description-term property-table-cell property-table-cell__description-term property-table-cell__vertical-center" };
const _hoisted_8 = { class: "cell cell-description-details property-table-cell property-table-cell__description-details d-flex flex-row ps-0 pe-0 property-table-cell__vertical-center" };
const _hoisted_9 = {
    key: 0,
    class: "placeholder-glow"
};
const _hoisted_10 = { class: "d-flex justify-content-end flex-row ms-auto" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_button = _resolveComponent("g-button");
    return (_ctx.schema.categories)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.schema.categories, (category) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_ctx.isVisibleCategory(category))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(category.displayName), 1),
                            (category._links?.updates?.href)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    (!category.editMode)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            onClick: ($event) => (_ctx.onEditClick(category)),
                                            class: "btn btn-primary btn-sm"
                                        }, "Bearbeiten", 8, _hoisted_4))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createVNode(_component_g_button, {
                                                text: "Speichern",
                                                "is-loading": category.isWorking,
                                                "button-style": "btn-primary btn-sm",
                                                class: "w-fixed-100",
                                                onClick: ($event) => (_ctx.onSaveClick(category))
                                            }, null, 8, ["is-loading", "onClick"]),
                                            _createVNode(_component_g_button, {
                                                text: "Abbrechen",
                                                "button-style": "btn btn-secondary btn-sm ms-2",
                                                class: "w-fixed-100",
                                                onClick: ($event) => (_ctx.onCancelClick(category))
                                            }, null, 8, ["onClick"])
                                        ], 64))
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            (category.properties)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(category.properties, (property) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                        (_ctx.isVisible(category, property))
                                            ? (_openBlock(), _createElementBlock("dl", _hoisted_6, [
                                                _createElementVNode("dt", _hoisted_7, _toDisplayString(_ctx.getDisplayName(category, property)), 1),
                                                _createElementVNode("dd", _hoisted_8, [
                                                    (_ctx.data === undefined || _ctx.data === null)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                            _createElementVNode("span", {
                                                                class: _normalizeClass('placeholder col-' + (Math.ceil(Math.random() * 12)) + '')
                                                            }, null, 2)
                                                        ]))
                                                        : (category.editMode && !property.isReadOnly)
                                                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getEditFieldType(property)), _mergeProps({ key: 1 }, property.attributes, {
                                                                "field-class": "m-0 p-0",
                                                                label: property.displayName,
                                                                "show-label": false,
                                                                "data-mode": "model",
                                                                "data-object": _ctx.data,
                                                                "data-member": property.name,
                                                                "form-context": _ctx.getFormContext(category)
                                                            }), null, 16, ["label", "data-object", "data-member", "form-context"]))
                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                _createTextVNode(_toDisplayString(_ctx.getCellValue(property)), 1)
                                                            ], 64)),
                                                    (property.commands)
                                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(property.commands, (cmd) => {
                                                            return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                                _createVNode(_component_g_button, {
                                                                    text: cmd.label,
                                                                    "button-style": "btn btn-primary btn-sm ms-2",
                                                                    class: "w-fixed-100",
                                                                    onClick: ($event) => (_ctx.onCommandClick(cmd))
                                                                }, null, 8, ["text", "onClick"])
                                                            ]));
                                                        }), 256))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 64));
                                }), 256))
                                : _createCommentVNode("", true)
                        ])
                    ], 64))
                    : _createCommentVNode("", true)
            ], 64));
        }), 256))
        : _createCommentVNode("", true);
}
